import { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { CmsApiPagePost } from 'modules/cms/api/types/CmsApiPage';
import {
  getContentLocaleUrl,
  getHideFooterDivider,
  getIsNoAdPage,
} from 'modules/cms/helpers';
import { getCmsApiPageDefaultSearchType } from 'modules/cms/helpers/getCmsApiPageDefaultSearchType';

type Args = {
  loggedIn: boolean;
  content: CmsApiPagePost;
};

export function getCmsPagePostLayoutHandleProps({
  loggedIn,
  content,
}: Args): LayoutHandleProps {
  const defaultSearchType = getCmsApiPageDefaultSearchType({ content });

  // banner ads should not be shown on some pages
  const noAds = getIsNoAdPage(content, loggedIn);

  const hideFooterDivider = getHideFooterDivider({ content });
  const localeUrl = getContentLocaleUrl({ content });

  return {
    noAds,
    defaultSearchType,
    hideFooterDivider,
    showDesktopSearch: true,
    urlByLocale: localeUrl,
  };
}
